var React = require('react');

function Reading (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m108.5 89.71s-12-4.27-24.81-1.43-19.69 10.38-19.69 10.38v-63s7.09-6.76 20.2-9.49a43.26 43.26 0 0 1 24.3 2.34z","key":0}),React.createElement("path",{"d":"m19.5 89.71s12.05-4.27 24.81-1.43 19.69 10.38 19.69 10.38v-63s-7.09-6.76-20.2-9.49a43.26 43.26 0 0 0 -24.3 2.34z","key":1}),React.createElement("path",{"d":"m10.12 42.52v59.19a54.54 54.54 0 0 1 26.41-6.59c19.09 0 27.47 7.54 27.47 7.54s8.12-7.54 27.47-7.54a54.54 54.54 0 0 1 26.41 6.59v-59.19","key":2})]));
}

Reading.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Reading;

Reading.default = Reading;
